import { SelectResult } from './SelectResult';
export var RecordsResult;
(function (RecordsResult) {
    function count(plan, result) {
        for (const query of plan.queries) {
            if (query.name === 'count') {
                return SelectResult.get(result, query);
            }
        }
    }
    RecordsResult.count = count;
    function countValue(plan, result) {
        var _a, _b;
        const countResult = count(plan, result);
        if ((countResult === null || countResult === void 0 ? void 0 : countResult.type) === "INLINE") {
            const [{ alias }] = countResult.columns;
            if ((_a = countResult.items) === null || _a === void 0 ? void 0 : _a.length) {
                return (_b = countResult.items[0][alias]) !== null && _b !== void 0 ? _b : 0;
            }
            else {
                return 0;
            }
        }
    }
    RecordsResult.countValue = countValue;
    function records(plan, result) {
        for (const query of plan.queries) {
            if (query.name === 'records') {
                return SelectResult.get(result, query);
            }
        }
    }
    RecordsResult.records = records;
    function recordsInline(plan, result) {
        const recordsResult = records(plan, result);
        if (recordsResult != null &&
            recordsResult.type === "INLINE") {
            return recordsResult;
        }
    }
    RecordsResult.recordsInline = recordsInline;
})(RecordsResult || (RecordsResult = {}));
